import { isValidNumber } from 'libphonenumber-js';
import { PhonePrefixes } from 'src/consts';

export const phonePrefixPatternBase = PhonePrefixes.join('|').replace(/\+/gi, '');

export const getPhoneFromFullPhone = (fullPhone: string): string | undefined => {
  if (!fullPhone) {
    return;
  }
  const reg = new RegExp(`\\+(${phonePrefixPatternBase})`);
  return fullPhone.replace(reg, '');
};

export const getPrefixFromFullPhone = (fullPhone: string): string | undefined => {
  if (!fullPhone) {
    return;
  }

  const reg = new RegExp(`\\+(${phonePrefixPatternBase})`);
  const matches = fullPhone.match(reg);

  return matches?.[0];
};

export const isValidPhone = (fullNumber: string): boolean => {
  const prefix = getPrefixFromFullPhone(fullNumber);

  if (!prefix) {
    return false;
  }

  const phone = getPhoneFromFullPhone(fullNumber);

  if (!phone) {
    return false;
  }

  if (phone.length !== 9) {
    return false;
  }

  return true;
};

export const isPhoneValid = (phone: string): boolean => {
  return isValidNumber(phone);
};

export const addPlusOnPhone = (phone: string): string => {
  if (phone.startsWith('+')) {
    return phone;
  }

  return `+${phone}`;
};
